import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      ACTIVE_ENVIREMENT_CHOICE: "Oppskrifter",
      YOU_WILL_FIND_DIGITAL_RECIPES_UNDER:
        "Du finner digitale oppskrifter under ",
      AND_YOU_CAN_OPT_OUT_OF_PHYSICAL_RECIPES:
        ", og kan derfor velge bort fysiske oppskriftsark.",

      MY_RECIPES_LABEL: "Mine oppskrifter",
      PRINTED_RECIPE_SHEETS_ARE_SENT_WITH: "Oppskriftsark sendes med.",
      THANX_YOU_TO_THINKING_ABOUT_ENVIREMENT:
        "Takk for at du tenker på miljøet!",
      GENERIC_ERROR_MESSAGE: "Noe gikk galt, kontakt support",
    },
    se: {
      ACTIVE_ENVIREMENT_CHOICE: "Receptblad",
      YOU_WILL_FIND_DIGITAL_RECIPES_UNDER:
        "Du hittar digitala receptblad under ",
      AND_YOU_CAN_OPT_OUT_OF_PHYSICAL_RECIPES:
        ". Om du vill kan du välja bort att få utskrivna receptblad med din leverans.",

      MY_RECIPES_LABEL: "Mina recept",
      PRINTED_RECIPE_SHEETS_ARE_SENT_WITH: "Utskrivna receptblad skickas med.",
      THANX_YOU_TO_THINKING_ABOUT_ENVIREMENT:
        "Tack för att du tänker på miljön",
      GENERIC_ERROR_MESSAGE: "Något gick fel, försök igen senare",
    },
    dk: {
      ACTIVE_ENVIREMENT_CHOICE: "Opskrifter",
      YOU_WILL_FIND_DIGITAL_RECIPES_UNDER:
        "Du kan se digitale opskrifter under ",
      AND_YOU_CAN_OPT_OUT_OF_PHYSICAL_RECIPES:
        " og kan derfor fravælge de udprintede opskrifter.",

      MY_RECIPES_LABEL: "Mine opskrifter",
      PRINTED_RECIPE_SHEETS_ARE_SENT_WITH: "Udprintede opskrifter sendes med.",
      THANX_YOU_TO_THINKING_ABOUT_ENVIREMENT: "Tak fordi du tænker på miljøet!",
      GENERIC_ERROR_MESSAGE: "Noget gik galt, kontakt support",
    },
  } as const
)[language];
